import { combineReducers } from 'redux'
import LoginReducers from './loginReducer'
import LogoutReducers from './logoutReducer'
import ForgotPasswordReducer from './forgotPasswordReducer'
import memberSummaryReducer from './memberSummaryReducer'
import BenefitReducer from './benefitReducer'
import LanguageReducers from './languageReducer'
import ActivateReducers from './activateReducer'
import UserProfileReducers from './userProfileReducer'
import HcsaReducer from './hcsaReducer'
import BenefitDetailsReducer from './benefitDetailsReducer'
import ClaimsReducer from './claimsReducer'
import EOBReducer from './eobReducer'
import ClaimLineReducer from './claimLineReducer'
import BenefitHistoryReducer from './benefitHistoryReducer'
import FAQReducer from './faqReducer'
import ResourcesReducer from './resourcesReducer'
import BenefitCardReducer from './benefitCardReducer'
import associatedClaimLinesReducer from './associatedClaimLinesReducer'
import SubmitAClaimReducer from './submitAClaimReducer'
import SubmitNavigationReducer from './submitNavigationReducer'
import SubmitExpenseReducer from './submitExpenseReducer'
import SubmitDentalExpenseReducer from './submitDentalExpenseReducer'
import SubmitPractitionerReducer from './submitPractitionerReducer'
import AppContentReducer from './appContentReducer'

const appReducer = combineReducers({
  LoginReducers,
  LogoutReducers,
  LanguageReducers,
  ForgotPasswordReducer,
  ActivateReducers,
  UserProfileReducers,
  memberSummaryReducer,
  HcsaReducer,
  BenefitDetailsReducer,
  FAQReducer,
  BenefitReducer,
  BenefitHistoryReducer,
  ClaimsReducer,
  EOBReducer,
  ResourcesReducer,
  ClaimLineReducer,
  BenefitCardReducer,
  associatedClaimLinesReducer,
  SubmitAClaimReducer,
  SubmitNavigationReducer,
  SubmitExpenseReducer,
  SubmitDentalExpenseReducer,
  SubmitPractitionerReducer,
  AppContentReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_SUCCESSFUL') {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js